import { FileSpreadsheet, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useDownloadPcmpBatchXlsx } from '../../hooks/useDownloadPcmpBatchXlsx';

interface PcmpExportButtonProps {
  /** Downloads the file; takes today's date for the file name. */
  download: (date: string) => Promise<void>;
  label?: string;
  /** What the file holds, for the tooltip. */
  title?: string;
  /** Held back, e.g. while there is nothing to export yet. */
  disabled?: boolean;
}

/**
 * An Excel download of the current queue view. A failure (nothing to export,
 * too many rows) is shown as the API words it.
 */
export function PcmpExportButton({
  download,
  label = 'Excel',
  title,
  disabled = false,
}: PcmpExportButtonProps) {
  const xlsx = useDownloadPcmpBatchXlsx(download);

  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      title={title}
      onClick={() => xlsx.mutate()}
      disabled={xlsx.isPending || disabled}
      className="gap-1.5"
    >
      {xlsx.isPending ? (
        <Loader2 className="size-3.5 animate-spin" />
      ) : (
        <FileSpreadsheet className="size-3.5" />
      )}
      {label}
    </Button>
  );
}
